! function(e) {
  e.fn.niceSelect = function() {
    this.each(function() {
      var s = e(this);
      if (!s.next().hasClass("nice-select") && !s.hasClass("nice-select")) {
        s.after('<div class="nice-select ' + (s.attr("class") || "") + (s.attr("disabled") ? "disabled" : '" tabindex="0') + '"><span class="current"></span><ul class="list"></ul></div>');
        var t = s.next(),
            n = s.find("option"),
            a = s.find("option:selected");
        t.find(".current").html('<span class="flags flags-' + a.data("country") + '"></span> &nbsp;' + a.data("display") || a.text()), n.each(function() {
          var s = e(this).data("display");
          t.find("ul").append('<li class="option ' + (e(this).is(":selected") ? "selected" : "") + '" data-value="' + e(this).val() + '" data-country="' + e(this).data("country") + (s ? '"  data-display="' + s : "") + '"><span class="flags flags-' + e(this).data("country") + '"></span> &nbsp;' + e(this).text() + "</li>")
        })
      }
    }), e(document).off(".nice_select"), e(document).on("click.nice_select", ".nice-select", function(s) {
      var t = e(this);
      e(".nice-select").not(t).removeClass("open"), t.toggleClass("open"), t.hasClass("open") ? (t.find(".option"), t.find(".focus").removeClass("focus"), t.find(".selected").addClass("focus")) : t.focus()
    }), e(document).on("click.nice_select", function(s) {
      0 === e(s.target).closest(".nice-select").length && e(".nice-select").removeClass("open").find(".option")
    }), e(document).on("click.nice_select", ".nice-select .option", function(s) {
      var t = e(this);
      e(".nice-select").each(function() {
        var s = e(this).find('.option[data-value="' + t.data("value") + '"]'),
            n = s.closest(".nice-select");
        n.find(".selected").removeClass("selected"), s.addClass("selected");
        var a = '<span class="flags flags-' + s.data("country") + '"></span> &nbsp;' + s.data("display") || s.text();
        n.find(".current").html(a), n.prev("select").val(s.data("value")).trigger("change")
      })
    }), e(document).on("keydown.nice_select", ".nice-select", function(s) {
      var t = e(this),
          n = e(t.find(".focus") || t.find(".list .option.selected"));
      if (32 == s.keyCode || 13 == s.keyCode) return t.hasClass("open") ? n.trigger("click") : t.trigger("click"), !1;
      if (40 == s.keyCode) return t.hasClass("open") ? n.next().length > 0 && (t.find(".focus").removeClass("focus"), n.next().addClass("focus")) : t.trigger("click"), !1;
      if (38 == s.keyCode) return t.hasClass("open") ? n.prev().length > 0 && (t.find(".focus").removeClass("focus"), n.prev().addClass("focus")) : t.trigger("click"), !1;
      if (27 == s.keyCode) t.hasClass("open") && t.trigger("click");
      else if (9 == s.keyCode && t.hasClass("open")) return !1
        })
  }
}(jQuery);